export const translations = {
  es: {
    hero: {
      title: 'Desbloquea tu Futuro con CortexAI',
      subtitle: '¿Estás listo para cerrar la brecha entre el aprendizaje y el empleo real?',
      description: 'Si es así, hemos construido algo especialmente para ti.',
      claim: 'CortexAI está redefiniendo cómo se desarrollan las habilidades y se descubre el talento.'
    },
    learners: {
      title: 'Para Estudiantes',
      intro: 'Imagina un viaje de aprendizaje donde no solo estudias, ¡sino que haces!',
      roles: {
        title: 'CortexAI te entrena para roles tecnológicos reales como:',
        list: [
          'Administrador de Azure',
          'Arquitecto de Azure',
          'Especialista en Ciberseguridad de Azure',
          'Ingeniero de IA de Azure'
        ]
      },
      skills: {
        title: 'Te equipamos con todas las habilidades necesarias para el rol:',
        list: [
          'Python',
          'React',
          'C#',
          'Gestión de Bases de Datos',
          'Desarrollo de APIs',
          'ITIL',
          'Y más...'
        ]
      },
      process: {
        title: 'Así es como funciona:',
        steps: [
          'Comienza con un entrenamiento inmersivo de 12 meses, adaptado a tu rol, guiado por tu Mentor IA personal.',
          'Obtén certificaciones opcionales para impulsar tu credibilidad.',
          'Ingresa a la Experiencia Virtual de Empleo en Empresa Digital (DCVEE):'
        ],
        dcvee: [
          'Experimenta un onboarding realista como un nuevo empleado.',
          'Utiliza herramientas empresariales y plataformas cloud reales.',
          'Colabora con equipos virtuales.',
          'Resuelve desafíos de implementación del mundo real.',
          'Recibe apoyo y feedback continuo de tu mentor IA.'
        ],
        outcome: 'Al final, tendrás conocimiento + experiencia práctica para respaldarlo.',
        payment: 'Y sí, puedes pagar en cuotas usando Klarna. Porque el acceso a formación de calidad nunca debería estar fuera de tu alcance.'
      }
    },
    dashboard: {
      student: {
        title: 'Panel de Control Interactivo para Estudiantes',
        features: [
          'Progreso en el desarrollo de habilidades (técnicas y blandas)',
          'Estado de completado de tareas y proyectos',
          'Registros de feedback del Mentor IA',
          'Seguimiento de preparación para certificaciones',
          'Gráficos de tendencias de rendimiento e insignias de logros',
          'Puntuaciones personalizadas de ajuste al rol basadas en el rendimiento'
        ]
      },
      employer: {
        title: 'Panel de Control Interactivo para Empleadores (DCVEE)',
        features: [
          'Tasas de éxito en tareas reales y resultados de proyectos',
          'Habilidades de resolución de problemas y registros de toma de decisiones',
          'Evaluaciones del Mentor IA por módulo',
          'Índice de preparación específico para el rol',
          'Comparación de candidatos top',
          'Cronogramas de finalización y progreso de certificaciones',
          'Evaluación de habilidades blandas de la colaboración en equipo virtual'
        ]
      }
    },
    cases: {
      employers: {
        title: 'Para Empleadores',
        cases: [
          {
            title: 'Reclutamiento Basado en Simulación Directo a Contratación',
            description: 'Una empresa SaaS en crecimiento utiliza CortexAI para evaluar candidatos a través de escenarios de proyectos reales antes de ofrecer trabajo, reduciendo el tiempo de contratación en un 70%.'
          },
          {
            title: 'Iniciativa de Recapacitación Empresarial',
            description: 'Una firma global de consultoría recapacita a 200 empleados de TI internos como Arquitectos de Azure usando CortexAI, reduciendo la dependencia de proveedores externos.'
          },
          {
            title: 'Asociación de Pipeline de Talento con Universidades',
            description: 'Un empleador fintech se asocia con CortexAI para crear una ruta de formación personalizada, obteniendo primer acceso a los mejores graduados listos para contribuir desde el primer día.'
          }
        ]
      },
      learners: {
        title: 'Para Estudiantes (Graduados y Cambios de Carrera)',
        cases: [
          {
            title: 'Cambio de Carrera de Marketing a Cloud',
            description: 'Un profesional de marketing de 35 años utiliza la ruta de Administrador de Azure de CortexAI para conseguir un puesto de ingeniero cloud junior en menos de 12 meses.'
          },
          {
            title: 'Graduado Buscando Experiencia Sin Trabajo',
            description: 'Un graduado reciente de TI se forma en CortexAI, construye un portfolio en la empresa virtual, y es contratado directamente por una firma de ciberseguridad basándose en métricas de rendimiento.'
          },
          {
            title: 'Estudiante a Tiempo Parcial Mejorando para Ganar Más',
            description: 'Un empleado de retail aprende en las noches usando la ruta de Ingeniero de IA de CortexAI y cambia a un rol tecnológico a tiempo completo en 18 meses.'
          }
        ]
      }
    },
    testimonials: {
      learners: {
        title: 'Lo que Dicen Nuestros Estudiantes',
        list: [
          {
            quote: 'CortexAI me dio la confianza y experiencia que no pude encontrar en ningún otro lugar. ¡La empresa virtual se sentía real, y ahora estoy trabajando en una real!',
            author: 'Diego R.',
            role: 'Estudiante de Admin de Azure'
          },
          {
            quote: 'El mentor de IA era como tener un coach disponible 24/7. Por fin entendí no solo qué hacer, sino cómo pensar como un ingeniero.',
            author: 'Fatima K.',
            role: 'Ruta de IA de Azure'
          }
        ]
      },
      employers: {
        title: 'Lo que Dicen los Empleadores',
        list: [
          {
            quote: 'Contraté a un candidato de CortexAI directamente desde su empresa virtual. Fue como incorporar a alguien que ya había trabajado con nosotros.',
            author: 'Laura M.',
            role: 'CTO de FinTech Cloud'
          },
          {
            quote: 'Redujimos los costos de consultoría en un 60% después de formar a nuestro equipo con CortexAI. Es la inversión más inteligente que hemos hecho.',
            author: 'Andres G.',
            role: 'Director de Transformación Digital'
          }
        ]
      }
    },
    cta: {
      title: '¿Listo para empezar?',
      buttons: {
        learner: 'Unirse como Estudiante',
        employer: 'Contratar con CortexAI',
        contact: 'Contáctanos'
      }
    }
  },
  en: {
    hero: {
      title: 'Unlock Your Future with CortexAI',
      subtitle: 'Are you ready to bridge the gap between learning and real-world employment?',
      description: 'Because if you are, we\'ve built something just for you.',
      claim: 'CortexAI is redefining how skills are developed and talent is discovered.'
    },
    learners: {
      title: 'For Learners',
      intro: 'Imagine a learning journey where you\'re not just studying—you\'re doing.',
      roles: {
        title: 'CortexAI trains you for real technology work roles like:',
        list: [
          'Azure Administrator',
          'Azure Architect',
          'Azure Cybersecurity Specialist',
          'Azure AI Engineer'
        ]
      },
      skills: {
        title: 'We equip you with every single skill required for that role:',
        list: [
          'Python',
          'React',
          'C#',
          'Database Management',
          'API Development',
          'ITIL',
          'And more...'
        ]
      },
      process: {
        title: 'Here\'s how it works:',
        steps: [
          'Start with 12-month immersive training, tailored to your role, guided by your personal AI Mentor.',
          'Get optional certifications to boost your credibility.',
          'Step into the Digital Company & Virtual Employment Experience (DCVEE):'
        ],
        dcvee: [
          'Experience realistic onboarding just like a new hire.',
          'Use real business tools and cloud platforms.',
          'Collaborate with virtual teams.',
          'Solve real-world implementation challenges.',
          'Receive continuous support and feedback from your AI mentor.'
        ],
        outcome: 'By the end, you\'ll have knowledge + hands-on experience to back it up.',
        payment: 'Oh, and yes — you can pay in installments using Klarna. Because access to quality training should never be out of reach.'
      }
    },
    dashboard: {
      student: {
        title: 'Interactive Training Dashboard for Students',
        features: [
          'Skill development progress (technical & soft skills)',
          'Task and project completion status',
          'AI Mentor feedback logs',
          'Certification readiness tracker',
          'Performance trend graphs and achievement badges',
          'Personalized role-fit scores based on task performance'
        ]
      },
      employer: {
        title: 'Interactive Employer Dashboard (DCVEE)',
        features: [
          'Real-world task success rates and project outcomes',
          'Problem-solving skills and decision-making logs',
          'AI Mentor evaluations per module',
          'Role-specific readiness index',
          'Comparison of top candidates',
          'Completion timelines and certification progress',
          'Soft skill evaluation from virtual team collaboration'
        ]
      }
    },
    cases: {
      employers: {
        title: 'For Employers',
        cases: [
          {
            title: 'Direct-to-Hire Simulation-Based Recruitment',
            description: 'A fast-growing SaaS company uses CortexAI to evaluate candidates through real project scenarios before offering a job, cutting hiring time by 70%.'
          },
          {
            title: 'Enterprise Reskilling Initiative',
            description: 'A global consulting firm reskills 200 internal IT employees into Azure Architects using CortexAI, reducing reliance on third-party vendors.'
          },
          {
            title: 'Talent Pipeline Partnership with Universities',
            description: 'A fintech employer partners with CortexAI to create a tailored training path, gaining first access to top graduates ready to contribute on day one.'
          }
        ]
      },
      learners: {
        title: 'For Learners (Graduates & Career Changers)',
        cases: [
          {
            title: 'Career Changer from Marketing to Cloud',
            description: 'A 35-year-old marketing professional uses CortexAI\'s Azure Administrator path to land a junior cloud engineer role in less than 12 months.'
          },
          {
            title: 'Graduate Seeking Experience Without a Job',
            description: 'A recent IT graduate trains in CortexAI, builds a portfolio in the virtual company, and gets hired directly by a cybersecurity firm based on performance metrics.'
          },
          {
            title: 'Part-Time Learner Upskilling to Earn More',
            description: 'A retail employee learns in the evenings using CortexAI\'s AI Engineer path and switches to a full-time tech role within 18 months.'
          }
        ]
      }
    },
    testimonials: {
      learners: {
        title: 'What Our Learners Say',
        list: [
          {
            quote: 'CortexAI gave me the confidence and experience I couldn\'t find anywhere else. The virtual company felt real—and now I\'m working at a real one!',
            author: 'Diego R.',
            role: 'Azure Admin Trainee'
          },
          {
            quote: 'The AI mentor was like having a coach available 24/7. I finally understood not just what to do—but how to think like an engineer.',
            author: 'Fatima K.',
            role: 'Azure AI Path'
          }
        ]
      },
      employers: {
        title: 'What Employers Are Saying',
        list: [
          {
            quote: 'I hired a CortexAI candidate straight from their virtual company. It was like onboarding someone who had already worked with us.',
            author: 'Laura M.',
            role: 'CTO of FinTech Cloud'
          },
          {
            quote: 'We reduced consulting costs by 60% after training our team with CortexAI. It\'s the smartest investment we\'ve made.',
            author: 'Andres G.',
            role: 'Head of Digital Transformation'
          }
        ]
      }
    },
    cta: {
      title: 'Ready to get started?',
      buttons: {
        learner: 'Join as a Learner',
        employer: 'Hire with CortexAI',
        contact: 'Contact Us'
      }
    }
  }
};